import { useEffect, useState } from 'react';
import RankingCard from '@/components/cards/RankingCard';
import AchievementRankingCard from '@/components/cards/AchievementRankingCard';
import ParchmentCard from '@/components/ui/ParchmentCard';
import * as rankingService from '@/services/rankingService';

const tabs = [
  { value: 'xp', label: 'XP Global' },
  { value: 'achievements', label: 'Conquistas' },
  { value: 'weekly', label: 'Semanal' },
];

export default function RankingPage() {
  const [tab, setTab] = useState('xp');
  const [entries, setEntries] = useState([]);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    setEntries([]);
    setStatus('');

    const fetch = tab === 'xp'
      ? rankingService.getGlobalRanking()
      : tab === 'weekly'
        ? rankingService.getWeeklyRanking()
        : rankingService.getAchievementRanking();

    fetch
      .then((res) => {
        const data = res.data.data;
        setEntries(data?.entries || []);
        if (!data?.entries?.length) setStatus('Nenhum jogador no ranking ainda.');
      })
      .catch(() => setStatus('Ranking indisponível de momento.'))
      .finally(() => setLoading(false));
  }, [tab]);

  return (
    <main className="h-full overflow-y-auto bg-background px-4 pb-4 pt-4">
      <h1 className="font-urban text-2xl font-black text-fg">Ranking</h1>
      <p className="text-xs font-black uppercase tracking-[0.18em] text-muted">
        Vê como te comparas com outros exploradores
      </p>

      <div className="mt-4 grid grid-cols-3 gap-2">
        {tabs.map((t) => (
          <button
            key={t.value}
            type="button"
            onClick={() => setTab(t.value)}
            className={`rounded-full border px-2 py-2 text-[11px] font-black transition ${
              tab === t.value ? 'border-accent bg-accent text-white' : 'border-edge bg-surface text-muted'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading && (
        <ParchmentCard className="mt-4 text-fg text-sm font-bold">A carregar ranking...</ParchmentCard>
      )}
      {!loading && status && (
        <ParchmentCard className="mt-4 text-fg text-sm font-bold">{status}</ParchmentCard>
      )}

      <div className="mt-4 grid gap-2">
        {tab === 'achievements'
          ? entries.map((entry, index) => (
              <AchievementRankingCard key={entry.player?.id || index} entry={entry} />
            ))
          : entries.map((entry, index) => (
              <RankingCard key={entry.id || index} entry={entry} index={index} />
            ))}
      </div>
    </main>
  );
}
